import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonAuthLoginService,
  TokenResponse,
  LoginByEmailTokenRequest,
  BaseLoginRequest,
  AnyValueModelUUID
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonAuthLoginApiService {
  constructor(private apiService: CommonAuthLoginService) {}

  public loginByEmailToken(body: LoginByEmailTokenRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TokenResponse> {
    return this.apiService.authLoginByEmailToken(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public loginByQrToken(qrToken: string, body: BaseLoginRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TokenResponse> {
    return this.apiService.authLoginByQRToken(qrToken, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public exchangeEmailToken(body: LoginByEmailTokenRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.exchangeEmailToken(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
